import { render, staticRenderFns } from "./TiptapTableButtons.vue?vue&type=template&id=a57076aa"
import script from "./TiptapTableButtons.vue?vue&type=script&lang=js"
export * from "./TiptapTableButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports